import { z } from 'zod';

export const clientPlatformAccountSchema = z.object({
  id: z.string(),
  displayName: z.string().nullable().optional(),
  externalId: z.string().nullable().optional(),
  profilePictureUrl: z.string().nullable().optional(),
  clientPlatformId: z.string(),
  dummy: z.boolean().default(false).optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  canPostToPlatform: z.boolean().default(false).optional(),
  tokenStatus: z.enum(['valid', 'expired', 'invalid']).nullable().optional(),
  tokenStatusCheckedAt: z.coerce.date().nullable().optional(),
});

export type ClientPlatformAccountSchema = z.infer<typeof clientPlatformAccountSchema>;
